export default __webpack_public_path__ + "static/media/addCart.31f4fc67.svg";